import type { Consultant } from "@karat/shared";
import { track } from "../analytics/track";
import { getTelegramWebApp } from "../telegram";

/**
 * п.20 ТЗ. Джерело не містить фото/Telegram/email для більшості консультантів — кнопка
 * "Написати в Telegram" рендериться лише якщо є telegramUsername, інакше залишається
 * "Зателефонувати" + "Надіслати заявку" (форма в Mini App, а не сподівання на невідомий контакт).
 */
export function ConsultantCard({ consultant, onSendLead }: { consultant: Consultant; onSendLead: () => void }) {
  const call = () => {
    track("select_consultant", { consultantId: consultant.id });
    window.location.href = `tel:+${consultant.phone}`;
  };
  const writeTelegram = () => {
    track("select_consultant", { consultantId: consultant.id });
    const wa = getTelegramWebApp();
    const url = `https://t.me/${consultant.telegramUsername}`;
    if (wa) wa.openTelegramLink(url);
    else window.open(url, "_blank");
  };

  return (
    <div className="card consultant-card">
      <div className="consultant-photo">
        {consultant.photoUrl ? <img src={consultant.photoUrl} alt={consultant.fullName} /> : <span>👤</span>}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: 15 }}>{consultant.fullName}</div>
        <div style={{ fontSize: 13, color: "var(--color-text-secondary)" }}>{consultant.position}</div>
        <div className="consultant-actions">
          <button className="btn btn-secondary btn-sm" onClick={call}>
            📞 Зателефонувати
          </button>
          {consultant.telegramUsername && (
            <button className="btn btn-secondary btn-sm" onClick={writeTelegram}>
              💬 Написати
            </button>
          )}
          <button className="btn btn-primary btn-sm" onClick={onSendLead}>
            Надіслати заявку
          </button>
        </div>
      </div>
    </div>
  );
}
